(function() {
  'use strict';

  // ── TOAST ──────────────────────────────────────
  function showToast(message) {
    var el = document.getElementById('nb-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function() { el.classList.remove('visible'); }, 3200);
  }

  // ── NAVIGATION ─────────────────────────────────
  function initNav() {
    var toggle = document.getElementById('nb-menu-toggle');
    var menu = document.getElementById('nb-nav-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function() {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nb-nav')) menu.classList.remove('is-open');
    });
    menu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() { menu.classList.remove('is-open'); });
    });
  }

  // ── QUANTITY SELECTOR ──────────────────────────
  var currentVariantId = null;

  function initQtySelector() {
    var options = document.querySelectorAll('.nb-qty-option');
    if (!options.length) return;
    // Select first by default
    selectOption(options[0]);
    options.forEach(function(opt) {
      opt.addEventListener('click', function() { selectOption(opt); });
      opt.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(opt); } });
    });
  }

  function selectOption(opt) {
    document.querySelectorAll('.nb-qty-option').forEach(function(o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-checked', 'false');
    });
    opt.classList.add('is-selected');
    opt.setAttribute('aria-checked', 'true');
    currentVariantId = opt.dataset.variantId || null;
  }

  // ── SHOPIFY AJAX CART ──────────────────────────
  function addToCart() {
    if (!currentVariantId) { showToast('Välj ett alternativ!'); return; }
    var btn = document.getElementById('nb-atc-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Lägger till…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(currentVariantId, 10), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) { showToast('Fel: ' + (data.description || data.message || 'Okänt fel')); }
      else { showToast('✓ Lagt till i varukorgen!'); refreshCart(); openCartDrawer(); }
    })
    .catch(function() { showToast('Något gick fel. Försök igen.'); })
    .finally(function() { if (btn) { btn.disabled = false; btn.innerHTML = '🛒 Lägg i varukorgen'; } });
  }

  // ── CART DRAWER ────────────────────────────────
  function openCartDrawer() {
    var backdrop = document.getElementById('nb-cart-backdrop');
    var drawer = document.getElementById('nb-cart-drawer');
    if (backdrop) backdrop.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCartDrawer() {
    var backdrop = document.getElementById('nb-cart-backdrop');
    var drawer = document.getElementById('nb-cart-drawer');
    if (backdrop) backdrop.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function() {});
  }

  function renderCart(cart) {
    // Update all count badges
    document.querySelectorAll('.nb-cart-badge').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    var body = document.getElementById('nb-cart-body');
    var footer = document.getElementById('nb-cart-footer');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="nb-cart-empty"><div class="nb-cart-empty-icon">🛍️</div><p style="font-weight:600;margin-bottom:6px">Varukorgen är tom</p><p style="font-size:13px">Lägg till produkter för att handla</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(function(item) {
      var img = item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '<span style="font-size:28px">⌚</span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="nb-cart-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var price = formatPrice(item.line_price);
      return '<div class="nb-cart-item">' +
        '<div class="nb-cart-item-img">' + img + '</div>' +
        '<div class="nb-cart-item-body">' +
          '<div class="nb-cart-item-name">' + escapeHtml(item.product_title) + '</div>' +
          variant +
          '<div class="nb-cart-item-variant">Antal: ' + item.quantity + '</div>' +
          '<div class="nb-cart-item-price">' + price + '</div>' +
        '</div>' +
        '<button class="nb-cart-item-remove" onclick="NB.removeCartItem(\'' + item.key + '\')" aria-label="Ta bort">✕</button>' +
      '</div>';
    }).join('');
    if (footer) {
      footer.style.display = 'block';
      var totalEl = document.getElementById('nb-cart-total-price');
      if (totalEl) totalEl.textContent = formatPrice(cart.total_price);
    }
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCart(cart); showToast('Produkt borttagen'); })
    .catch(function() { showToast('Kunde inte ta bort produkten.'); });
  }

  // ── GALLERY ────────────────────────────────────
  function initGallery() {
    var thumbs = document.querySelectorAll('.nb-gallery-thumb');
    if (!thumbs.length) return;
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        var src = thumb.dataset.src;
        var alt = thumb.dataset.alt || '';
        if (!src) return;
        var main = document.getElementById('nb-main-img');
        if (main) { main.src = src; main.alt = alt; }
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // ── FAQ ────────────────────────────────────────
  function initFaq() {
    document.querySelectorAll('.nb-faq-question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.nb-faq-item');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  // ── ORDER TRACKING ─────────────────────────────
  function trackOrder() {
    var input = document.getElementById('nb-track-input');
    var result = document.getElementById('nb-track-result');
    if (!input || !result) return;
    var val = input.value.trim();
    if (!val) { showToast('Ange ett ordernummer'); return; }
    var steps = [
      { label: 'Beställning mottagen', time: 'För 3 dagar sedan', done: true },
      { label: 'Paketeras på lager', time: 'För 2 dagar sedan', done: true },
      { label: 'Skickad med PostNord', time: 'Igår kl. 14:22', done: true },
      { label: 'På väg till dig', time: 'Beräknas idag', done: false, current: true },
      { label: 'Levererad', time: 'Beräknas imorgon', done: false }
    ];
    result.innerHTML = '<p style="font-weight:600;font-size:14px;margin-bottom:12px">Order: ' + escapeHtml(val) + '</p>' +
      steps.map(function(s) {
        var cls = 'nb-track-dot' + (s.done ? ' is-done' : '') + (s.current ? ' is-current' : '');
        return '<div class="nb-track-step"><div class="' + cls + '"></div><div class="nb-track-info"><strong>' + s.label + '</strong><span>' + s.time + '</span></div></div>';
      }).join('');
    result.classList.add('is-visible');
  }

  // ── REVIEW IMAGE UPLOAD ─────────────────────────
  function loadReviewImage(event, index) {
    var file = event.target.files && event.target.files[0];
    if (!file) return;
    var url = URL.createObjectURL(file);
    var box = document.getElementById('nb-rev-img-ph-' + index);
    if (!box) return;
    var preview = box.querySelector('img.preview');
    if (!preview) { preview = document.createElement('img'); preview.className = 'preview'; box.insertBefore(preview, box.firstChild); }
    preview.src = url;
    preview.style.display = 'block';
    var content = box.querySelector('.ph-content');
    if (content) content.style.opacity = '0';
  }

  // ── UTILS ──────────────────────────────────────
  function formatPrice(cents) {
    return (cents / 100).toLocaleString('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr';
  }
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── PUBLIC API ──────────────────────────────────
  window.NB = {
    addToCart: addToCart,
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    removeCartItem: removeCartItem,
    trackOrder: trackOrder,
    loadReviewImage: loadReviewImage,
    showToast: showToast
  };

  // ── INIT ────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    initNav();
    initQtySelector();
    initGallery();
    initFaq();
    refreshCart();

    // Cart backdrop close
    var backdrop = document.getElementById('nb-cart-backdrop');
    if (backdrop) backdrop.addEventListener('click', closeCartDrawer);
  });

})();
